import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 bg-[#1a3a52] text-white" data-id="element-176">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-177">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[#0f2942] rounded-3xl p-8 md:p-12 border border-[#C9A961]/30 flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-178">
          <div className="flex-shrink-0" data-id="element-179">
            <div className="w-32 h-32 bg-[#C9A961]/10 rounded-full flex items-center justify-center border-2 border-[#C9A961] relative" data-id="element-180">
              <ShieldCheck size={64} className="text-[#C9A961]" data-id="element-181" />
              <div className="absolute -bottom-3 bg-[#C9A961] text-[#1a3a52] text-xs font-bold px-3 py-1 rounded-full" data-id="element-182">
                100% SEGURO
              </div>
            </div>
          </div>

          <div className="text-center md:text-left" data-id="element-183">
            <h3 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-184">
              Garantía de Satisfacción de 30 Días
            </h3>
            <p className="text-gray-300 leading-relaxed mb-6" data-id="element-185">
              Estoy tan seguro de que este material transformará tus ventas que
              asumo todo el riesgo. Si aplicas lo aprendido y no ves resultados,
              o simplemente sientes que no es para ti, envíame un correo y te
              devolveré el 100% de tu dinero. Sin preguntas.
            </p>
            <p className="text-[#C9A961] font-serif italic text-lg" data-id="element-186">
              Tu inversión está totalmente protegida.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}